// semeia-disable-reexport
import type AbilitiesService from "ember-can/services/abilities";
import AlertTriggeredJournalEvent from "parog-web/models/alert-triggered-journal-event";
import type SurveyRequestedJournalEvent from "parog-web/models/survey-requested-journal-event";
import type SemeiaSessionService from "parog-web/services/session";

export function surveyRequestedForCurrentUser({
  jes,
  authenticatedAs
}: {
  jes: SurveyRequestedJournalEvent[];
  authenticatedAs: string;
}) {
  if (authenticatedAs === "medic") {
    return jes.filter(je => je.isVisibleOnlyByMedics);
  } else if (authenticatedAs === "patient") {
    return jes.filter(je => je.isVisibleOnlyByPatient);
  }
  return [];
}

export function availableSurveyRequestedForPatient({
  surveyRequestedJes,
  session,
  abilities
}: {
  surveyRequestedJes: SurveyRequestedJournalEvent[];
  session: SemeiaSessionService;
  abilities: AbilitiesService;
}) {
  let authenticatedAs;
  if (session.patient) authenticatedAs = "patient";
  if (session.medic) authenticatedAs = "medic";

  const surveyRequested = surveyRequestedForCurrentUser({
    jes: surveyRequestedJes,
    authenticatedAs
  });

  return surveyRequested.filter(event => {
    return (
      !event.isNew &&
      !event.isArchived &&
      !event.isExpired &&
      event.isNotCompleted &&
      abilities.can("edit form", event.formId)
    );
  });
}

export function alertsToDisplay({
  events,
  abilities
}: {
  events: AlertTriggeredJournalEvent[];
  abilities: AbilitiesService;
}) {
  return events
    .filter(event => !event.isArchived)
    .filter(event => {
      if (!(event instanceof AlertTriggeredJournalEvent)) return false;
      const ability = abilities.abilityFor(
        "alert-triggered-journal-event",
        event
      );
      return ability.get("canList") && !event.hasBeenProcessed;
    });
}
